import { render, staticRenderFns } from "./ProductSizeChart.vue?vue&type=template&id=54d8c91d&"
import script from "./ProductSizeChart.vue?vue&type=script&lang=js&"
export * from "./ProductSizeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports